export default __webpack_public_path__ + "static/media/schema-exodon.23d45892.png";